import ContentHeader from "../../components/layout/ContentHeader/ContentHeader";
import Section from "../../components/layout/Section/Section";
import Hr from "../../components/ui/Hr/Hr";
import { Box, Container } from "@mui/material";
import { useEffect, useState } from "react";
import { apiClient } from "../../services/api_client";
import NavBreadcrumbs from "../../components/navigation/NavBreadcrumbs/NavBreadcrumbs";
import { PAGE } from "../../constants/page";
import GridTable from "../../components/display/GridTable/GridTable";
import ContentTitle from "../../components/layout/ContentTitle/ContentTitle";
import OtherSection from "../../components/display/OtherSection/OtherSection";
import { scrollIntoView } from "../../utils/scrollIntoView";

interface Props {
  children?: React.ReactElement<unknown>;
}

export default function Company(props: Props) {
  /** 読み込み中判定 */
  const [isLoading, setIsLoading] = useState<boolean>(true)
  /** 会社概要 */
  const [profile, setProfile] = useState<Profile>({
    companyName: '',
    ownerName: '',
    establishment: '',
    capital: '',
    shareholder: '',
    location: '',
    contact: '',
    business: '',
    clients: '',
    contract: '',
    licenses: '',
    organizations: ''
  })
  /** アクセス */
  const [access, setAccess] = useState<Access>({
    address: '',
    station: '',
    spot: '',
    map: ''
  })

  /** PROFILEカラム */
  const [profileColumns, setProfileColumns] = useState<Array<GridTableColumn<Profile>>>([
    {
      field: 'companyName',
      label: '企業名',
    },
    {
      field: 'ownerName',
      label: '代表者名',
    },
    {
      field: 'establishment',
      label: '設立',
    },
    {
      field: 'capital',
      label: '資本金',
    },
    {
      field: 'shareholder',
      label: '株主',
    },
    {
      field: 'location',
      label: '所在地',
    },
    {
      field: 'contact',
      label: 'お問い合わせ先',
    },
    {
      field: 'business',
      label: '事業概要',
    },
    {
      field: 'clients',
      label: '主要取引先',
    },
    {
      field: 'contract',
      label: '契約形態',
    },
    {
      field: 'licenses',
      label: '資格・認定',
    },
    {
      field: 'organizations',
      label: '加盟団体',
    }
  ])

  /** ACCESSカラム */
  const [accessColumns, setAccessColumns] = useState<Array<GridTableColumn<Access>>>([
    {
      field: 'address',
      label: '住所',
    },
    {
      field: 'station',
      label: '最寄駅',
    },
    {
      field: 'spot',
      label: 'スポット',
    },
    {
      field: 'map',
      label: 'マップ',
      renderCell: (access: Access, index: number) => (
        <Box component={'iframe'}
          src={access.map}
          width="100%"
          height="500px"
          loading="lazy"
          sx={{
            border: 0
          }}
        />
      )
    }
  ])

  useEffect(() => {
    // 会社情報取得API
    const fetchData = async () => {
      const getInformation = await apiClient.getInformation({
        // mock: 'GetInformation.json'
      }).finally(() => {
        setIsLoading(false)
      })
      setProfile(getInformation.profile)
      setAccess(getInformation.access)
    }
    fetchData()
  }, [])

  useEffect(() => {
    scrollIntoView()
  }, [profile, access])

  return (
    <>
      <Section color="dark">
        <ContentHeader title={PAGE.COMPANY.NAME} subTitle={PAGE.COMPANY.TEXT} />
      </Section>

      <Section color="light" padding="1rem 0">
        <Container>
          <NavBreadcrumbs />
        </Container>
      </Section>

      <Section color="light">
        <Container id="profile">
          <ContentTitle title={'PROFILE'} subTitle={'会社概要'} />
          <GridTable color="light" columns={profileColumns} data={profile} isLoading={isLoading} />
        </Container>
      </Section>

      <Hr />

      <Section color="light">
        <Container id="access">
          <ContentTitle title={'ACCESS'} subTitle={'所在地'} />
          <GridTable color="light" columns={accessColumns} data={access} isLoading={isLoading} />
        </Container>
      </Section >

      <Hr />

      <Section color='dark' height={'300px'} backgroundImage='url(/assets/images/top.jpg)' isBackgroundCover>
        <Container>
          <OtherSection isObserver={false} />
        </Container>
      </Section>
    </>
  )
}